import gql from 'graphql-tag'

export const ACCOUNT_CHANGE_STATUS_MUTATION = gql`
    mutation accountChangeStatus(
        $id: ID!
        $status: AccountStatus!
    ) {
        accountChangeStatus(
            id: $id
            status: $status
        ) {
            id
            type
            status
            number
            name
            description
            balance
            has_postings
            is_assigned
            assignedTo {
                ... on Person {
                    id
                }
                ... on Company {
                    id
                }
                ... on CommissionTypeAccountingConfiguration {
                    id
                }
            }
            assigned_as_type
            created_at
            updated_at
        }
    }
`
